import { render, staticRenderFns } from "./dialog-dashboardoutbox.vue?vue&type=template&id=0ecd1b84&"
import script from "./dialog-dashboardoutbox.vue?vue&type=script&lang=js&"
export * from "./dialog-dashboardoutbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports